import { UserGeneratedHtml } from "@trueskin-web/components"

const SubscriptionBenefitsList = ({ benefits }) => (
  <ul
    data-testid="web-portal-plan-selection-subscription-benefits"
    sx={{
      position: "relative",
      mt: 2,
      mb: 0,
      pl: 4,
      fontSize: 1,
      "& > li": {
        py: 1,
        listStyle: "none",
        "&:before": {
          content: '"•"',
          position: "absolute",
          ml: "-16px",
          fontSize: 2,
          lineHeight: 1.25,
        },
        "& span": {
          color: "textDark",
        },
      },
    }}
  >
    {benefits.map((line, index) => (
      <li key={index}>
        <UserGeneratedHtml html={line} />
      </li>
    ))}
  </ul>
)

export default SubscriptionBenefitsList
